"use strict";

import React, { Component, PropTypes } from "react";

import FormComponentBase from ".\\FormComponentBase";

/******************************************************************************
** Submit
*/

export default class Submit extends FormComponentBase {

	render() {
		return (
				<div ref="topContainer" className={this.props.containerClassNames}>
					<input type="submit" id={this.state.clientId} name={this.props.name} className={this.props.inputClassNames} value={this.props.title} />
				</div>
			);
	}

}



/** WEBPACK FOOTER **
 ** ./forms/Submit.jsx
 **/